import wrapComponent from "../../core/wrapComponent";
// import Modal, {
//   ModalProps,
// } from './default'
import { Modal } from "../../_/@ui-kitten/components";
export default wrapComponent( // @ts-ignore
Modal, {});